import latin from './latin';

/*
 * The typography values for Latin and Cyrillic characters are identical
 */
const cyrillic = latin;

export default cyrillic;
